import { ComponentSelector, ComponentInjector } from '@atypon/ui-utils';

import PhotoQuickSearch, {
    PhotoQuickSearchElements,
    PhotoQuickSearchSelectors,
    PhotoQuickSearchTexts,
    PhotoQuickSearchClassList
} from 'ui-theme/widgets/quick-search/js/quick-search';
import LargeQuery from "../../../utility/large-query/js/large-query";

class Texts extends PhotoQuickSearchTexts { }

class ClassList extends PhotoQuickSearchClassList {}

class Selectors extends PhotoQuickSearchSelectors {
    qsAutocomplete = new ComponentSelector('input.auto-complete , textarea.auto-complete');
    btnWithKeyWord = new ComponentSelector('#btnWithKeyWord');
    keyWordInputFiled = new ComponentSelector('#keyWordInputFiled');
    qSearch = new ComponentSelector('#qsearch');
    textarea = new ComponentSelector('.search__page textarea');
    searchButton = new ComponentSelector('.search__page .searchButton');
    quickSearchForm = new ComponentSelector('.quick-search__form');
    largeQueryModalBtn = '.large-query-message-btn';
}

class Elements extends PhotoQuickSearchElements {
    qsAutocomplete: Array<HTMLInputElement> = [];
    keyWordInputFiled: HTMLElement;
    qSearch: HTMLElement;
    btnWithKeyWord: HTMLElement;
    textarea: HTMLTextAreaElement;
    searchButton: HTMLElement;
    quickSearchForm: HTMLElement;
}

interface QuickSearch {
    get elements(): Elements;
    get texts(): Texts;
    get classList(): ClassList;
    get selectors(): Selectors;
}

class QuickSearchElm {
    constructor(public el: HTMLInputElement, public searchType: string, public seriesKey: string) { }
}

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class QuickSearch extends PhotoQuickSearch {

    addEventListeners(): void {
        // Core
        if (this.isAutocompleteOn && !this.browserUtils.isIE) {
            this.elements.qsAutocomplete.forEach(input => {
                input.addEventListener('keydown', this.onKeyDown.bind(this, input));
            });
        }

        if (this.elements.qsDropdowns && this.elements.qsDropdowns.length > 0) {
            this.elements.qsDropdowns.forEach(item => {
                item.addEventListener('click', this.handleDropdownCollapse.bind(this, item));
            })
        }

        this.registerCitationSearchEvents();

        //Photo
        this.registerAutoCompleteInputEvents();
        this.registerCitationSearchEvents();
        this.registerTogglerOverlayEvents();

        // Cabi
        if (this.elements.btnWithKeyWord) {
            this.addEventOnBtnWithKeyword();
        }
        if (this.elements.textarea) {
            this.makeTextAreaExpandable();
        }

        this.elements.quickSearchForm.addEventListener('submit', this.switchFormMethod.bind(this, this.elements.quickSearchForm));

        this.autocompleteAnnouncer();

    }


    protected onKeyDown(input: HTMLInputElement, e: KeyboardEvent,) {
        if (e.keyCode === 13) {
            // this is necessary since the autocomplete plugin prevents default on Enter
            const submitForm = () => this.domUtils.closest('form', input).dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            if (this.submitWithoutChoosingValue) {
                if (this.domUtils.getElement(this.selectors.autocompleteSelectedResultItem, this.wrapper)) {
                    return
                }
                return submitForm();
            } else if (input.value !== '') {
                return
            }
        }
    }

    protected makeTextAreaExpandable(): void {
        function calculateRowsNeeded(textarea: HTMLTextAreaElement): number {
          const clone = textarea.cloneNode(true) as HTMLTextAreaElement;
          clone.style.height = '20px';
          clone.style.width = getComputedStyle(textarea).width;
          clone.value = textarea.value;
          document.body.appendChild(clone);
          const lineHeight = parseFloat(getComputedStyle(textarea).lineHeight);
          const rowsNeeded = Math.round(clone.scrollHeight / lineHeight);
          document.body.removeChild(clone);
          return rowsNeeded;
        }
      
        const textarea = this.elements.textarea;
        const searchButton = this.elements.searchButton;

        textarea.addEventListener('keyup', () => {
          setTimeout(() => {
            textarea.rows = calculateRowsNeeded(textarea) - 1;
            searchButton.style.height = getComputedStyle(textarea).height;
          }, 250);
        });
    }

    protected addEventOnBtnWithKeyword(){
        let btnWithKeyWord = this.elements.btnWithKeyWord;
        let keyWordInputFiled = this.elements.keyWordInputFiled;
        let qSearch = this.elements.qSearch;

        btnWithKeyWord.addEventListener('click' , function(e){
            e.preventDefault();
            window.open(
                '/action/doSearch?KeywordRaw=' +
                keyWordInputFiled.getAttribute('value') +
                    '&text1=' +
                    qSearch.getAttribute('value') +
                    '&field1=AllField',
                '_self'
            );
        })
    }

    protected switchFormMethod(qsForm: HTMLFormElement, e: Event) {
        e.preventDefault();
        const qsAutocompleteInputs = this.elements.qsAutocomplete;

        qsAutocompleteInputs.forEach(input => {
            const query = encodeURIComponent(input.value).replace(/%20/g, '+');
            let isLargeQuery: boolean = LargeQuery.checkIfLargeQuery(query, '/action/doSearch?AllField=', true);
            LargeQuery.submit(qsForm, isLargeQuery);
        });
    }

    // It should be removed after the core level changes in ticket LIT-505435 is merged
    protected resultListConfig(quickSearchElm: QuickSearchElm) {
        return { ...super.resultListConfig(quickSearchElm), maxResults: 10 };
    }
}

export default QuickSearch;